(function () {
  // 1. Spiek in de adresbalk of we in een taal-mapje zitten (zoals /nl/)
  const pathMatch = window.location.pathname.match(/^\/([a-z]{2}(-[a-z]{2})?)\//);
  const langPrefix = pathMatch ? pathMatch[0] : '/';
  
  // 2. Plak de taal netjes voor de link
  const DETAILS_URL = langPrefix + 'pages/ticket-holder-details';

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  function needsTicketDetails(cart) {
    return cart.items.some((it) => {
      const props = it.properties || {};
      const requires = props['_gt_requires_holders'] === '1';
      if (!requires) return false;

      const hasName = !!props['Ticket holder name'];
      const hasDob = !!props['DOB'];

      return it.quantity > 0 && (!hasName || !hasDob);
    });
  }

  function bindCartPageSubmitGuard(state) {
    // Cart page checkout is usually a form submit
    const forms = document.querySelectorAll('form[action="/checkout"], form[action*="/checkout"]');
    forms.forEach((form) => {
      if (form.dataset.gtGuardBound) return;

      form.addEventListener('submit', function (e) {
        if (state.needsDetails) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = DETAILS_URL;
        }
      }, true);

      form.dataset.gtGuardBound = '1';
    });

    // Extra safety: intercept checkout button clicks too
    const btns = document.querySelectorAll('button[name="checkout"], [name="checkout"], a[href="/checkout"]');
    btns.forEach((btn) => {
      if (btn.dataset.gtGuardBound) return;

      btn.addEventListener('click', function (e) {
        if (state.needsDetails) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = DETAILS_URL;
        }
      }, true);

      btn.dataset.gtGuardBound = '1';
    });
  }

  function updateDrawerLink(state) {
    // Drawer link can be a link or button depending on Dawn version
    const selectors = [
      '#CartDrawer-Checkout',
      '.cart-drawer__footer a[href="/checkout"]',
      '.cart-drawer__footer button[name="checkout"]',
      'a[href="/checkout"]'
    ];

    let el = null;
    for (const sel of selectors) {
      const found = document.querySelector(sel);
      if (found && found.closest('.cart-drawer, cart-drawer, #CartDrawer')) {
        el = found;
        break;
      }
    }
    if (!el) return;

    if (el.tagName.toLowerCase() === 'a') {
      el.setAttribute('href', state.needsDetails ? DETAILS_URL : '/checkout');
    } else {
      el.dataset.gtCheckoutUrl = state.needsDetails ? DETAILS_URL : '/checkout';

      if (!el.dataset.gtGuardBound) {
        el.addEventListener('click', function (e) {
          const url = el.dataset.gtCheckoutUrl;
          if (url && url !== '/checkout') {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = url;
          }
        }, true);
        el.dataset.gtGuardBound = '1';
      }
    }
  }

  async function refresh(state) {
    try {
      const cart = await getCart();
      state.needsDetails = needsTicketDetails(cart);

      updateDrawerLink(state);
      bindCartPageSubmitGuard(state);
    } catch (e) {
      // niets doen als cart niet laadt
      console.warn(e);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const state = { needsDetails: false };

    refresh(state);

    // Drawer open/updates without reload
    document.addEventListener('cart:refresh', () => refresh(state));
    document.addEventListener('cart:updated', () => refresh(state));

    // Fallback: when user opens cart drawer
    document.addEventListener('click', function (e) {
      const t = e.target;
      if (!t) return;

      if (
        t.closest('[aria-controls*="CartDrawer"]') ||
        t.closest('button[aria-controls*="CartDrawer"]') ||
        t.closest('a[href*="/cart"]')
      ) {
        setTimeout(() => refresh(state), 250);
      }
    });
  });
})();